import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import _ from 'underscore'

import styles from './article-preview.module.css'

export default ({ event }) => (
  <Link to={`/event/${event.slug}`}>
    <div className={styles.cardItem}>
      <Img alt={event.title} sizes={event.thumbnail.sizes} className={styles.cardImage} />
      <div className={styles.cardInfo}>
        <h3 className={styles.cardTitle}>{event.title}</h3>
        <div className={styles.eventDate}><strong>Tanggal:</strong> {event.date}</div>
        <div className={styles.eventLocation}><strong>Tempat:</strong> {event.venue}</div>
        <div className={styles.cardExcerpt}>{event.excerpt}</div>
      </div>
    </div>
  </Link>
)



// WEBPACK FOOTER //
// ./src/components/event-preview.js